import { Card, CardBody, HStack, Text, VStack } from "@chakra-ui/react";
import { Chips, TooltipTime } from "@equidefi/ui";

import { SectionMiniTitle } from "@/areas/Investments/components/Sections";
import type { TInvestmentDTO } from "@/types/dto";

interface InvestmentDetailsCardProps {
  investment: TInvestmentDTO;
}

export const InvestmentDetailsCard: React.FC<InvestmentDetailsCardProps> = ({ investment }) => {
  if (!investment) return null;

  return (
    <Card>
      <CardBody>
        <VStack align="stretch" spacing={4}>
          <SectionMiniTitle>Investment Details</SectionMiniTitle>

          <VStack align="start" spacing={3} _empty={{ display: "none" }}>
            {investment.expedited && (
              <HStack>
                <Chips.Expedited size="sm" variant="expedited" tooltipText="Expedited Investment" />
                <Text color="gray.700" fontSize="md" my="0">
                  Expedited Investment
                </Text>
              </HStack>
            )}

            {investment.is_reinvestment && (
              <HStack>
                <Chips.Returning size="sm" variant="info" tooltipText="Returning Investor" />
                <Text color="gray.700" fontSize="md" my="0">
                  Returning Investor
                </Text>
              </HStack>
            )}

            {investment.investment_notes?.length > 0 && (
              <HStack>
                <Chips.Notes size="sm" variant="unknown" tooltipText="Has Notes" />
                <Text color="gray.700" fontSize="md" my="0">
                  Has Notes
                </Text>
              </HStack>
            )}

            {investment.vault?.broker_dealer && (
              <HStack>
                <Chips.BrokerDealer size="sm" variant="info" tooltipText="Broker-Dealer Affiliated" />
                <Text color="gray.700" fontSize="md" my="0">
                  Broker-Dealer Affiliated
                </Text>
              </HStack>
            )}
          </VStack>

          <VStack align="stretch" spacing={0}>
            <Text textStyle="body2" color="gray.600" my="0">
              Started: <TooltipTime datetime={investment.create_date} tooltip="llll" format="MMM Do, YYYY" />
            </Text>
            <Text textStyle="body2" color="gray.600" my="0">
              Last updated: <TooltipTime datetime={investment.modify_date} tooltip="llll" format="MMM Do, YYYY" />
            </Text>
            {investment.broker && (
              <Text textStyle="body2" color="gray.600" my="0">
                Broker: {investment.broker.full_name}
              </Text>
            )}
            {investment.affiliate && (
              <Text textStyle="body2" color="gray.600" my="0">
                Affiliate: {investment.affiliate.name}
              </Text>
            )}
          </VStack>

          <VStack align="stretch" spacing={0}>
            <Text textStyle="body2" color="gray.600" my="0">
              Step: {investment.next}
            </Text>
            <Text textStyle="body2" color="gray.600" my="0">
              Status: {investment.status}
            </Text>
            <Text textStyle="body2" color="gray.600" my="0">
              ID: {investment.id}
            </Text>
          </VStack>
        </VStack>
      </CardBody>
    </Card>
  );
};
